import { render } from "./BookView.vue?vue&type=template&id=4d571d06"
import script from "./BookView.vue?vue&type=script&lang=js"
export * from "./BookView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__